// Minnesotaänger Mini App — Telegram Mini App fullscreen integration.
// v1 (fix-list J): extracted from index.tsx init() into a plain module so
// the unsupported-client fallbacks are unit-testable. Nothing here throws
// when Telegram.WebApp is absent; the app boots exactly as before.
// New code (not from telegram-tt).

export interface TgWebAppLike {
  ready?: () => void;
  expand?: () => void;
  requestFullscreen?: () => void;
  isFullscreen?: boolean;
  onEvent?: (event: string, callback: () => void) => void;
}

// Mirror WebApp.isFullscreen onto a queryable class on <html>
// (`tg-fullscreen`) for CSS and support tooling.
export function reflectFullscreen(tgWebApp: TgWebAppLike | undefined): void {
  document.documentElement.classList.toggle(
    'tg-fullscreen',
    Boolean(tgWebApp?.isFullscreen),
  );
}

// v1 (fix-list B): request real Mini App fullscreen right away, then keep
// the class in sync with WebApp.isFullscreen. Safe fallback: any missing
// capability (desktop browser, old SDK, unsupported client) is skipped.
export function initTelegramFullscreen(tgWebApp: TgWebAppLike | undefined): void {
  if (!tgWebApp) return;

  // WebView 标准调用：页面就绪后通知 Telegram 关闭加载动画，并展开到全高。
  tgWebApp.ready?.();
  tgWebApp.expand?.();

  reflectFullscreen(tgWebApp);
  try {
    tgWebApp.requestFullscreen?.();
  } catch (err) {
    // Never break startup on a fullscreen rejection.
    // eslint-disable-next-line no-console
    console.warn('[miniapp] requestFullscreen failed:', err);
  }
  tgWebApp.onEvent?.('fullscreenChanged', () => {
    reflectFullscreen(tgWebApp);
  });
  tgWebApp.onEvent?.('fullscreenFailed', () => {
    document.documentElement.classList.remove('tg-fullscreen');
  });
}
